"use client";

import { useEffect } from "react";
import { useSearchParams } from "next/navigation";
const LocaleSettingComponent: React.FC = () => {
  const searchParams = useSearchParams();
  useEffect(() => {
    if (typeof window !== "undefined") {
      const flValue = searchParams.get("fl");
      if (flValue) {
        localStorage.setItem("locale", flValue);
      }
    }
  }, [searchParams]);
  return null;
};
export default LocaleSettingComponent;